import { Body, Box, DropDown, H3, H4 } from '../widgets'
import './PriceSelect.scss'

export const PriceSelect = ({ value = 0, onTeamOptionSelected, dark, pricing }) => {
  const { price } = pricing[value < pricing.length ? value : 0]

  return <Box justifyContent='space-between' fullWidth gap={8}>
    <Box gap={32} width="50%">
      <Box className="header-with-sub-element">
        {price
          ? <>
              <H3 align="left" color={dark ? "black" : "white"}>${price}</H3>
              <Body lineHeight="100%" size={14} align="left" bold color={dark ? "black" : "white"}>USD p/a</Body>
            </>
          : <H4 align="left" color={dark ? "black" : "white"}>Contact us</H4>
        }
      </Box>
    </Box>
    {pricing.length > 1 &&
      <Box className="subscription-drop-down header-with-sub-element">
        <Body bold align="right" color={dark ? "black" : "white"}>Number of teams</Body>
        <DropDown
          options={pricing.map((x, index) => ({
            label: x.teams,
            value: index
          }))}
          value={value}
          onChange={(value) => onTeamOptionSelected(value)}
          dark={dark}
          alt
        />
      </Box>
    }
  </Box>
}